/**
 * @Description 基诺浦定制组件详情
 */

import { FC } from 'react';
import TableDetail from '@/common/components/business/DynamicComponent/components/CalculationJNP/components/TableDetail';
import {
  CostExpenseConfig,
  EmployeeCompensationCostConfig,
  LeaseCostConfig,
  OperatingIncomeConfig,
  OtherCostConfig,
  SaleTargetConfig,
  storeEngineeringCostConfig,
  StoreImageCostConfig
} from '@/common/components/business/DynamicComponent/components/CalculationJNP/ts-config';
import { isNotEmptyAny } from '@lhb/func';

const CalculationJNPDetail: FC<any> = ({ value }) => {
  return (isNotEmptyAny(value) ? <>
    <TableDetail moduleConfig={SaleTargetConfig} jnpObject={value}/>
    <TableDetail moduleConfig={OperatingIncomeConfig} jnpObject={value}/>
    <TableDetail moduleConfig={CostExpenseConfig} jnpObject={value}/>
    <TableDetail moduleConfig={EmployeeCompensationCostConfig} jnpObject={value}/>
    <TableDetail moduleConfig={StoreImageCostConfig} jnpObject={value}/>
    <TableDetail moduleConfig={storeEngineeringCostConfig} jnpObject={value}/>
    <TableDetail moduleConfig={LeaseCostConfig} jnpObject={value}/>
    <TableDetail moduleConfig={OtherCostConfig} jnpObject={value}/>
  </> : <></>);
};

export default CalculationJNPDetail;
